import React, { FC, useEffect, useCallback } from 'react';
import { useSelector, useDispatch } from 'react-redux';

import { OnSelectProductHandler } from '@app/react/uikit';
import { hideEcHeaderNavi } from '@app/react/common/Function';
import { useOrderPathParams } from '@app/react/contexts/useOrderPathParams';
import { PartsProduct } from '@app/react/const/type';
import type { AppState } from '@app/react/reducer';
import { IinitState } from '@app/react/reducer/PartsSelectReducer';
import {
    partsSelectActions,
    apiGetActions,
} from '@app/react/action';
import { showOrderPartsHelpAction } from '@app/react/action/showOrderPartsHelp';
import { OrderFeatherinsideSelectComponent } from '@component/index';
import { useMediaDesktop, useMediaMobile } from '@app/react/common/useMedia';
import { isDisableFeatherinside } from '@app/react/common/isDisableFeatherinside';
import { selectOrderPartsHelp } from './selectors';

const selectFeather = (state: AppState): PartsProduct | null => state.customize.feather;

export const OrderFeatherinsideSelectContainer: FC<{ waitFetch?: boolean }> = ({ waitFetch = false }) => {
    const dispatch = useDispatch();
    const { arrowType, orderType } = useOrderPathParams();
    const isDesktop = useMediaDesktop();
    const isMobile = useMediaMobile();

    const customizeData = useSelector<AppState, IinitState>(
        (state) => state.customize,
    );
    const product = useSelector<AppState, PartsProduct | null>(
        (state) => state.customize.featherinside,
    );
    const feather = useSelector(selectFeather);
    const featherOpt = feather?.options ?? {};
    const disabledFeatherInside = isDisableFeatherinside(featherOpt);

    const openHelpParts = useSelector(selectOrderPartsHelp);
    const isOpenHelp = openHelpParts === 'featherinside';

    const handleClick: OnSelectProductHandler = (__, p) => {
        dispatch(partsSelectActions.featherinside.started({ param: p }));
    };

    const openHelp = useCallback(() => {
        dispatch(showOrderPartsHelpAction({ partsName: 'featherinside' }));
    }, [dispatch]);

    const closeHelp = useCallback(() => {
        dispatch(showOrderPartsHelpAction({ partsName: null }));
    }, [dispatch]);

    useEffect(() => {
        hideEcHeaderNavi(isDesktop, isMobile, dispatch);
    }, [isDesktop, isMobile, dispatch]);

    useEffect(() => {
        if (waitFetch) {
            console.log('initializing, waiting fetch');
            return;
        }
        dispatch(
            apiGetActions.featherinside.started({
                arrowType,
                orderType,
                selectItems: customizeData,
            }),
        );
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [dispatch, arrowType, orderType, waitFetch]);

    return (
        <OrderFeatherinsideSelectComponent
            selectedProduct={product}
            onSelectProduct={handleClick}
            allDisabled={disabledFeatherInside}
            isHelpOpen={isOpenHelp}
            handleHelpOpen={openHelp}
            handleHelpClose={closeHelp}
        />
    );
};
